import store from "../../../store";

import {commit, make} from 'vuex-pathify'

// initial state
function defaultState() {
    return {
        modal_active_tab:'faq',
        show_infos_modal:false,
        show_help_modal:false,

        step_mounted_status:true,
        step_before_mount_status:true,
        go_to_status:true,

        disable_form:false,

        validation_observer: null,

        enter_animate_status: false,
        back_animate_status: false,
        leave_animate_status: false,
        back_enter_status: false,

        match_token:null,
        form_token:null,
        phone:null,

        lang:null,
        country:null,

        test_iban:"BE54000000000097",
        is_test:0,

        utm_source: null,

        localities:[],

        lastname: null,
        firstname: null,
        progress_one_step_left : null,

        query_string: {},
    }
}

const state = defaultState();

// getters
const getters = {
    defaultState : (state) => {
        return defaultState();
    },
    loading(state){
        return !(state.go_to_status  && state.step_mounted_status && state.step_before_mount_status)
    },
    block_form(state){
        return !(state.go_to_status  && state.step_mounted_status && state.step_before_mount_status && !(state.enter_animate_status || state.leave_animate_status || state.back_animate_status))
    }
}

// actions
const actions = {
    openInfosModal(state, tab) {
        store.set('func_data/modal_active_tab',tab);
        store.set('func_data/show_infos_modal',true);
    },
    openHelpModal(state, tab) {
        store.set('func_data/show_help_modal',true);
    }
}

// mutations
const mutations = {
    ...make.mutations(state),
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
